import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';

type Props = {
    cardIcon: any,
    cardTitle: string,
    cardText: string,
    cardLinkUrl: string,
    cardLinkText: string,
}

export default function NavCard ({ cardIcon, cardTitle, cardText, cardLinkUrl, cardLinkText }: Props) {
    return(
        <>
            <div className="nav-card">
                <div className="nav-card-icon">
                    <FontAwesomeIcon 
                        icon={cardIcon} 
                        color="var(--color-dot-blue-primary)"
                        transform="grow-45"
                    />                  
                </div>
                <div className="nav-card-contents">
                    <div className="nav-card-contents-desc">
                        <div className="nav-card-contents-desc-title">
                            {cardTitle}
                        </div>
                        <div className="nav-card-contents-desc-text" >
                            {cardText}
                        </div>
                    </div>
                    <NavLink 
                        to={cardLinkUrl}
                        className="nav-card-contents-link"
                    >
                        {cardLinkText}
                    </NavLink>
                </div>
            </div>
        </>
    );
}